// extracted by mini-css-extract-plugin
export default {"container":"CheckProducts_container__Faik8","image":"CheckProducts_image__921zq","productimage":"CheckProducts_productimage__YeLLF"};